import AmpEvents from '@amplify/amp-events';

const getEnvironmentName = () => {
    if (window.amplify_lantern_config && window.amplify_lantern_config.trackingServiceEnvironment) {
        const trackingEnvironment = window.amplify_lantern_config.trackingServiceEnvironment;
        if (trackingEnvironment === 'staging') {
            return AmpEvents.ENVIRONMENTS.STAGING;
        }
        if (trackingEnvironment === 'production') {
            return AmpEvents.ENVIRONMENTS.PRODUCTION;
        }
    }
    return AmpEvents.ENVIRONMENTS.DEVCI;
};

export default getEnvironmentName;
